import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import IconGroupsContainer from 'components/projectForm/methodStatement/icons/components/IconGroupsContainer';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <IconGroupsContainer {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
